import React from "react";
import Styles from "../styles.module.scss";
import { useTranslation } from "react-i18next";

const steps = [
    {
        id: 1,
        label: "Метод",
    },
    {
        id: 2,
        label: "Настройка",
    },
    {
        id: 3,
        label: "Резервные коды",
    },
];

const Stepper = ({ currentStep }) => {
    const { t } = useTranslation();

    return (
        <div className={Styles.stepperWrap}>
            {steps.map((step, index) => {
                const isActive = currentStep === step.id;
                const isDone = currentStep > step.id;
                const isLast = index === steps.length - 1;

                return (
                    <React.Fragment key={step.id}>
                        <div
                            className={`
                                ${Styles.stepperItem}
                                ${isActive ? Styles.stepperItemActive : ""}
                                ${isDone ? Styles.stepperItemDone : ""}
                            `}
                        >
                            <div className={Styles.stepperCircle}>
                                {isDone ? (
                                    <span className={Styles.stepperCheck} />
                                ) : (
                                    step.id
                                )}
                            </div>

                            <div className={Styles.stepperLabel}>
                                {t(step.label)}
                            </div>
                        </div>

                        {!isLast && (
                            <div
                                className={`
                                    ${Styles.stepperLine}
                                    ${isDone ? Styles.stepperLineDone : ""}
                                `}
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default Stepper;